@if(image && !!image?.filename){
    <img class="{{imageClass}}" [alt]="imageAlt" height="{{height}}" width="{{width}}" [src]="imageSrc" [attr.loading]="loadEager ? 'eager' : 'lazy'" />
}